export default __webpack_public_path__ + "2de50ad5cd2b3ea107b94a1fb4ad4389.svg";